module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "use-plex-step"
    }
  }, _vm._l((_vm.currentPlatformSteps), function(detail, index) {
    return _c('div', {
      staticClass: "details"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('step')) + " " + _vm._s(index + 1))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": detail.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(detail.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(detail.explain))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27f3d1fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/download/usePlexStep/UsePlexStep.vue
// module id = 1285
// module chunks = 1